export { default as ReporteIngreso } from "./ReporteIngresoContainer";
